import { Cookies, resetCookieConsentValue } from "react-cookie-consent";

/** Cookie that stores the visitor's choice in the cookie banner ("true" | "false"). */
export const CONSENT_COOKIE = "clicksdmp-consent";
/** Days the choice is remembered. */
export const CONSENT_DAYS = 365;

/** Fired on window after the visitor accepts or declines (detail: "true" | "false"). */
export const CONSENT_CHANGED_EVENT = "clicksdmp:consent-changed";
/** Fired on window when the visitor wants to change the choice ("Cookie-Einstellungen"). */
export const OPEN_CONSENT_EVENT = "clicksdmp:open-consent";

export type ConsentValue = "true" | "false" | null;

/** Reads the stored choice. Returns null on the server and when nothing was chosen yet. */
export function readConsent(): ConsentValue {
  if (typeof document === "undefined") return null;
  const value = Cookies.get(CONSENT_COOKIE);
  if (value === "true") return "true";
  if (value === "false") return "false";
  return null;
}

export function hasAnalyticsConsent(): boolean {
  return readConsent() === "true";
}

export function announceConsent(value: "true" | "false") {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<"true" | "false">(CONSENT_CHANGED_EVENT, { detail: value }));
}

/** Removes the stored choice (and the legacy cookie the banner library writes). */
export function clearConsent() {
  if (typeof document === "undefined") return;
  resetCookieConsentValue(CONSENT_COOKIE);
}

/** Opens the banner again so the visitor can change the choice. */
export function openConsentSettings() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(OPEN_CONSENT_EVENT));
}
